import React from "react";
import { ReportRerunSummary, ReportSummaryItemApi } from "../../api/Reports";
import RerunReportBanner from "../RerunReportBanner";

interface Props {
  report: ReportSummaryItemApi;
  reportReruns: ReportRerunSummary[] | undefined;
}

const Summary360RerunBanner = ({ report, reportReruns }: Props) => (
  <RerunReportBanner
    report={report}
    reportReruns={reportReruns}
    variant="summary"
  />
);

export default Summary360RerunBanner;
